// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"123":"d7f4f28f","352":"8000a9c2"}[chunkId] + ".chunk.js";
};